import httpClient from '@/mixins/http-client'
import GroupRepository from '@/modules/users/group/infrastructure/persistence/api/axios/group_repository'

export default class CreateGroupService {
  private repository: GroupRepository | null

  constructor(_repository: GroupRepository | null = null) {
    this.repository = _repository || new GroupRepository(httpClient, '/groups/')
  }

  create(payload: object) {
    return this.repository?.create(payload)
  }
}
